module.exports = __webpack_public_path__ + "media/images/brands/marque-revlonissimo-116742b864d87941e5b7bb5ffb7c00b3.jpg";